import React from 'react';
import { Helmet } from 'react-helmet';

export default () => (
    <Helmet>
        <meta name='robots' content='noindex' />
    </Helmet>
);
